import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {app} from "app/app";
import 'assets/sass/dashboard/layout/HeaderUser.scss';


export class HeaderUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            user: app.currentUser()
        };

        this.toggleMenu = this.toggleMenu.bind(this);
        this.hideMenuOnClickOutside = this.hideMenuOnClickOutside.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.logOutUser = this.logOutUser.bind(this);
    }

    toggleMenu() {
        const lastState = this.state.isOpen;
        this.setState({isOpen: !lastState});
    }

    hideMenuOnClickOutside(event) {
        if (!this.node.contains(event.target)) {
            this.hideMenu();
        }
    }

    hideMenu() {
        this.setState({isOpen: false});
    }

    logOutUser() {
        app.logOutUser();
        window.location.replace(app.routes().index);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.hideMenuOnClickOutside, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.hideMenuOnClickOutside, false);
    }

    render() {
        return (
            <div ref={node => this.node = node}
                 className={"dashboard-header--user " + (this.state.isOpen ? 'open' : '')}>
                <div className="user-menu" onClick={this.toggleMenu}>
                    <div className="user-avatar">{this.state.user.initials()}</div>
                    <div className="user-name">
                        <div className="name">{this.state.user.fullName()}</div>
                    </div>

                    <div className="arrow">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.14 10.57">
                            <g>
                                <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                                      d="M16.64 1.5L9.07 9.07 1.5 1.5"/>
                            </g>
                        </svg>
                    </div>
                </div>
                <div className="user-nav">
                    <div className="user-nav--profile" onClick={this.toggleMenu}>
                        <div className="user-name">
                            <div className="name">{this.state.user.fullName()}</div>
                            <div className="profile">@{this.state.user.profileName()}</div>
                        </div>
                        <div className="user-avatar">{this.state.user.initials()}</div>

                        <div className="arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.14 10.57">
                                <g>
                                    <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                                          d="M16.64 1.5L9.07 9.07 1.5 1.5"/>
                                </g>
                            </svg>
                        </div>

                    </div>
                    <Link className="nav-item" to={app.routes().dashboard.user.profile} onClick={this.hideMenu}>Mi
                        perfil</Link>
                    {/*<Link className="nav-item" to={app.routes().verification}>Verificación</Link>*/}
                    <Link className="nav-item" to={app.routes().dashboard.user.configuration}
                          onClick={this.hideMenu}>Configuración</Link>
                    <a className="nav-item" href={app.helpUrl()}>Ayuda</a>
                    <div className="nav-item" onClick={this.logOutUser}>Cerrar sesión</div>
                </div>
            </div>
        );
    }
}
